import { localStorageNames } from "./enums";

/* LPPLWEBMOB-454 */
export class ListOfFiles {
  static multiFiles: FileRecord[];
  static frontImage: FileRecord;
  static backImage: FileRecord;
  private static listOfFiles: ListOfFiles | null;
  constructor() {
    ListOfFiles.multiFiles = new Array<FileRecord>();
    ListOfFiles.backImage = {
      fileId: "",
      fileIndex: 0,
      ifFileIsPdf: false,
    };
    ListOfFiles.frontImage = {
      fileId: "",
      fileIndex: 0,
      ifFileIsPdf: false,
    };
  }

  static GetListOfFiles(): ListOfFiles {
    if (ListOfFiles.listOfFiles == null)
      ListOfFiles.listOfFiles = new ListOfFiles();
    return ListOfFiles.listOfFiles;
  }

  Add(
    fileUploader: "frontImage" | "backImage" | "multi",
    file: FileRecord,
    index: number
  ) {
    if (fileUploader == "frontImage") {
      ListOfFiles.frontImage = file;
    } else if (fileUploader == "backImage") {
      ListOfFiles.backImage = file;
    } else {
      ListOfFiles.multiFiles.push(file);
    }
    return this;
  }

  Remove(
    fileUploader: "frontImage" | "backImage" | "multi",
    file: FileRecord,
    index: number
  ) {
    if (fileUploader == "frontImage") {
      ListOfFiles.frontImage.fileId = "";
    } else if (fileUploader == "backImage") {
      ListOfFiles.backImage.fileId = "";
    } else {
      ListOfFiles.removeSingleArrayElement(index, ListOfFiles.multiFiles);
    }
  }

  Search(fileId: string): ["frontImage" | "backImage" | "multi", number] {
    for (let index = 0; index < ListOfFiles.multiFiles.length; index++) {
      if (ListOfFiles.multiFiles[index].fileId == fileId)
        return ["multi", index];
    }
    if (ListOfFiles.backImage.fileId == fileId) return ["backImage", 0];
    return ["frontImage", 0];
  }

  private static removeSingleArrayElement(
    index: number,
    array: Array<FileRecord>
  ) {
    for (let i = index; i < array.length - 1; i++) {
      array[i].fileId = array[i + 1].fileId;
      array[i].fileIndex = array[i + 1].fileIndex;
      array[i].ifFileIsPdf = array[i + 1].ifFileIsPdf;
    }
    array.pop();
  }
}

export type FileRecord = {
  fileId: string;
  ifFileIsPdf: boolean;
  fileIndex: number;
};

export function removeLocalStorageVariable(
  imageNumber: number,
  maxImageNumber: number
) {
  for (let i = imageNumber; i < maxImageNumber; i++) {
    localStorage.setItem(
      localStorageNames.MultiImageIfpdf + i.toString(),
      localStorage.getItem(
        localStorageNames.MultiImageIfpdf + (i + 1).toString()
      ) as string
    );
  }
  localStorage.removeItem(
    localStorageNames.MultiImageIfpdf + maxImageNumber.toString()
  );
  localStorage.setItem(
    localStorageNames.MultiImageNumber,
    (maxImageNumber - 1).toString()
  );
}
/* LPPLWEBMOB-454 END */
